import { api } from '@/redux/api';
import { ApplicationUser } from '@/types/application-user';

const emptyUser: ApplicationUser = {
  id: -1,
  firstName: 'Unknown',
  lastName: 'Unknown',
  email: '',
  role: { id: -1, roleName: '' },
};

export type UseUSerReturn = {
  user: ApplicationUser;
};

export const useUser = (): UseUSerReturn => {
  const { data: user } = api.useGetUserQuery();

  if (!user) {
    console.warn(
      'useUser hook is being called when there is no user. It should only be called inside an authenticated route where the user is available',
    );
    return {
      user: emptyUser,
    };
  }

  return {
    user: user,
  };
};
